export enum EngineServicePartnerActionTypes {
  SET_ENGINE_SERVICE_PARTNER_DATA = 'SET_ENGINE_SERVICE_PARTNER_DATA',
  SET_SELECTED_ENGINE_SERVICE_PARTNER_DATA = 'SET_SELECTED_ENGINE_SERVICE_PARTNER_DATA',
  CLEAR_SELECTED_ENGINE_SERVICE_PARTNER_DATA = 'CLEAR_SELECTED_ENGINE_SERVICE_PARTNER_DATA',
}
